import { render, staticRenderFns } from "./EventLinksList.vue?vue&type=template&id=8215c96e&scoped=true"
import script from "./EventLinksList.vue?vue&type=script&lang=ts"
export * from "./EventLinksList.vue?vue&type=script&lang=ts"
import style0 from "./EventLinksList.vue?vue&type=style&index=0&id=8215c96e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8215c96e",
  null
  
)

export default component.exports